import colors from 'styles/colors';

const Favorite = () => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.1254 2.45624L13.133 2.44821L13.1405 2.44001C14.8768 0.532058 17.8032 0.505212 19.6599 2.44823C21.4571 4.43197 21.4338 7.62067 19.6675 9.47718L11.0365 18.5492L2.40556 9.47718L2.3979 9.46913L2.39007 9.46125C0.545033 7.60625 0.52309 4.43491 2.40556 2.45624L2.4132 2.44821L2.42066 2.44001C4.15932 0.52944 7.09146 0.505141 8.94771 2.45624L10.312 3.8903L11.0365 4.65182L11.761 3.8903L13.1254 2.45624Z"
        strokeWidth="2"
        stroke={colors.secondary.deepCove}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Favorite;
